export { default as FilterBarDesktop } from './filter-bar-desktop.component'
